import React from 'react';
import { DrillDownModal } from './DrillDownModal';
import { FornecedorDrillDownContent } from './FornecedorDrillDownContent';
import { DRILL_DOWN_CONFIGS } from '../../types/drillDown';
import { FornecedorDrillDownData } from '../../types/drillDown';
import { UseDrillDownReturn } from '../../types/drillDown';

interface FornecedorDrillDownProps {
  drillDown: UseDrillDownReturn<FornecedorDrillDownData, { nome: string }>;
}

export const FornecedorDrillDown: React.FC<FornecedorDrillDownProps> = ({ drillDown }) => {
  const { isModalOpen, data, loading, error, selectedItem, closeModal, retry, openModal } = drillDown;

  return (
    <DrillDownModal
      config={DRILL_DOWN_CONFIGS.fornecedor}
      state={{ isModalOpen, data, loading, error, selectedItem }}
      actions={{ closeModal, retry, openModal }}
    >
      {data && <FornecedorDrillDownContent data={data} />}
    </DrillDownModal>
  );
}; 